import { DataSourceOptionKind, CommonResourceKind as ResourceKind } from '@powerquery/mashup-editor-client';
import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { GitHubLinkedService } from 'app/model/linkedservice/github.linkedservice';
import { format } from 'app/shared/utils/string.util';

export const gitHubMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(GitHubLinkedService).name,
    displayName: stringResources.GitHubLabel,
    linkedServiceKind: 'file',
    icon: {
        className: 'svg-i-20x20-github'
    },
    isFirstClass: true,
    supportDatasetV2: true,
    disableQueryAPI: true,
    supportDataFlowSource: true,
    supportDataFlowSink: true,
    category: ['ServicesApps'],
    notSupportCopySource: true,
    notSupportCopySink: true,
    copySinkTypes: [],
    copySourceTypes: [],
    supportedInTrident: true,
    pqoDataSourceOption: {
        kind: DataSourceOptionKind.Extension,
        resourceKind: 'GitHubSourceControl' as ResourceKind
    },
    controls: [
        {
            type: 'textbox',
            bind: 'username',
            label: stringResources.ModelName_UserName,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'dynamic-akv-switcher',
            bind: 'credential',
            label: stringResources.ModelName_Password,
            child: {
                type: 'password',
                label: stringResources.ModelName_Password,
                isLabelVertical: true,
                required: true
            },
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                stringResources.GitHubLabel,
                stringResources.ModelName_Password)
        }
    ]
};
